// import './index.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';

type FSwiperProps = {
    children: any[];
};

const FSwiper: React.FC<FSwiperProps> = (props: FSwiperProps) => {
    const { children } = props;
    const prefixCls = `f-swiper`;

    return (
        <Swiper slidesPerView={'auto'} modules={[Navigation]} spaceBetween={0} navigation={true} className={prefixCls}>
            {children.map((item, index: number) => {
                return (
                    <SwiperSlide key={index} className={`${prefixCls}-item`}>
                        {item}
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
};

export default FSwiper;
